module.exports = __webpack_public_path__ + "img/service01.b56380e7.jpg";